export default __webpack_public_path__ + "static/media/AG01.2.393a4ca1.mp3";